module.exports = __webpack_public_path__ + "fonts/icomoon.be506cd0.eot";